import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var shortVowelsAtStart = {
  a: 'ا',
  e: 'ا',
  i: 'إ',
  o: 'اوو',
  u: 'أُو'
};
export var shortVowels = {
  a: 'َ',
  e: 'ِّ',
  i: 'ِ',
  o: 'و',
  u: 'ُ'
};
export var longVowels = {
  aa: 'ا',
  ee: 'ي',
  ii: 'ي',
  oo: 'و',
  uu: 'و'
};
export var numbers = {
  0: '٠',
  1: '١',
  2: '٢',
  3: '٣',
  4: '٤',
  5: '٥',
  6: '٦',
  7: '٧',
  8: '٨',
  9: '٩'
};
export var punctuationAndSpaces = {
  '.': '.',
  '!': '!',
  '?': '؟',
  ',': '،',
  '#': '#',
  '\n': '\n',
  '\r': '\r',
  '\t': '\t'
};
export var consonants = {
  "'": 'ء',
  b: 'ب',
  t: 'ت',
  j: 'ج',
  x: 'ح',
  kh: 'خ',
  d: 'ط',
  r: 'ر',
  s: 'س',
  sh: 'ش',
  dh: 'ڎ',
  c: 'ع',
  g: 'گ',
  f: 'ف',
  q: 'ق',
  k: 'ك',
  l: 'ل',
  m: 'م',
  n: 'ن',
  w: 'و',
  h: 'ه',
  y: 'ي'
}; // by default, we will be ignoring shortVowels from the alphabet
// only on the start of a word, shortVowels are included. See FarWadaadScript.parse for details

export var alphabet = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, numbers), punctuationAndSpaces), longVowels), consonants);